<video
  #videoPlayer
  appLazyViewport
  [lazyVideoSrc]="resolvedSrc()"
  [lazyStrategy]="lazyStrategy()"
  [attr.aria-label]="videoLabel()"
  (entered)="onVideoEntered()"
  loop
  playsinline
  draggable="false"
></video>
